import React from "react";
import Modal from "../UI/Modal";
import Button from "../UI/Button";

import { useDispatch, useSelector } from "react-redux";

import { popupActions } from "../../store/popup-slice";

import classes from "./ProgramPopup.module.css";

const ProgramPopup = () => {
  const dispatch = useDispatch();
  const programPopup = useSelector((state) => state.popup.programPopup);

  const ProgramPopupHide = (event) => {
    dispatch(popupActions.setProgramPopupHide());
  };

  return (
    programPopup && (
      <Modal onClose={ProgramPopupHide}>
        <div>
          <h1>Wellness Program Selection</h1>
          <h2>
            A choice or combination of any of our Wellness Programs <br />
            (all wellness program prices are the same)
          </h2>

          <p>
            The final combination of wellness programs can be determined in the
            program consultation on the morning that the program commences.
            <br />
            <br />
            Prior to confirmation of the booking, it is necessary to complete
            our pre-screening process so that our wellness consultants can
            advise if there are any contraindications to our colon cleansing,
            fasting, or wellness programs
          </p>
          <a
            className={classes.linkStyle}
            href="https://www.amitywellness.com/thailand-fasting-and-detox#wellness-programs"
            rel="noopener noreferrer"
            target="_blank"
          >
            Click here to view programs (This link will redirect you to our
            website)
          </a>
          <center>
            <Button onClick={ProgramPopupHide} buttonText="Close" />
          </center>
        </div>
      </Modal>
    )
  );
};

export default ProgramPopup;
